import React, { PureComponent } from 'react';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Link from '../../components/link';
import LOGO from './corporate_logo_2.svg';

const Section = styled.div`
  background: #181818;
  position: relative;
  padding: 2em 0 1em;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 767px) {
    z-index: 4;
  }

  a {
    text-decoration: none;
  }
`;

const Text = styled.p`
  margin: 0.8em 0;
`;

const Social = styled.div`
  width: 60%;
  max-width: 30em;
  margin-top: 3.5em;
  display: flex;
  justify-content: space-around;
  > a {
    color: inherit;
  }
`;

const Logo = styled.img`
  height: 4em;
  margin-top: 2em;
`;

const Copyright = styled.small`
  color: #919191;
  display: block;
  font-size: 0.8em;
  margin: 1.5em;
`;

class Footer extends PureComponent {
  render() {
    const { gameId } = this.props;
    return (
      <Section>
        <Text>
          <Link to="/terms-of-service/">
            <Translate id="landingPage.footer.terms" />
          </Link>
        </Text>
        <Text>
          <Link to={`/games/${gameId}/disclaimer/`}>
            <Translate id="landingPage.footer.disclaimer" />
          </Link>
        </Text>
        <a
          href="https://pretiaar.com/corporate/business/"
          rel="noopener noreferrer"
          style={{ color: 'inherit' }}
          target="_blank"
        >
          <Text>
            <Translate id="landingPage.footer.company" />
          </Text>
        </a>
        <Text>
          <Link to="/privacy-policy/">
            <Translate id="landingPage.footer.policy" />
          </Link>
        </Text>
        <Text>
          <Link to="/sales-notice/">
            <Translate id="landingPage.footer.salesNotice" />
          </Link>
        </Text>
        <Text>
          <Link to="/contact/">
            <Translate id="landingPage.footer.contact" />
          </Link>
        </Text>
        <Social>
          <a
            href="https://twitter.com/ARpuzzle_"
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaTwitter size="2.5em" />
          </a>
          <a
            href="https://www.instagram.com/arpuzzle_/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaInstagram size="2.5em" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCJRJQl3SlEQKNe6EylX0pFw"
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaYoutube size="2.5em" />
          </a>
        </Social>
        <a
          href="https://pretiaar.com/corporate/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Logo alt="Logo" src={LOGO} />
        </a>
        <Copyright>
          <Translate id={`landingPage.footer.copyright.${gameId}`} />
        </Copyright>
      </Section>
    );
  }
}

Footer.propTypes = {
  gameId: PropTypes.string.isRequired
};

export default Footer;
